import { render, staticRenderFns } from "./app-mrb-reason.vue?vue&type=template&id=b22afa64&scoped=true&"
import script from "./js/app-mrb-reason.js?vue&type=script&lang=js&"
export * from "./js/app-mrb-reason.js?vue&type=script&lang=js&"
import style0 from "./app-mrb-reason.vue?vue&type=style&index=0&id=b22afa64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22afa64",
  null
  
)

export default component.exports